import React from 'react';
import { Route, IndexRedirect } from "react-router";
import ReportGenerate from './ReportingTemplate/ReportGenerate';
import ReportingTemplateList from './ReportingTemplate/ReportingTemplateList';
import ReportingTemplateModify from './ReportingTemplate/ReportingTemplateModify';
import TabBar from '../TabBar';
import DataDeliveryLogs from "./DataDeliveryLogs";
import DataDeliveryParameterTemplate from "./DataDeliveryParameterTemplate";
import DataExportAdd from "./DataExport/DataExportAdd";
import DataExportEdit from "./DataExport/DataExportEdit";
import DataExportList from "./DataExport/DataExportList";
import DataExportRun from "./DataExport/DataExportRun";
import RawDataExportList from './RawDataExport/RawDataExportList';
import RawDataExportModify from './RawDataExport/RawDataExportModify';
import RawDataExportAudit from './RawDataExport/RawDataExportAudit';
import ReportingTemplateIndex from './ReportingTemplate/ReportingTemplateIndex';
import ReportingHeaderList from './ReportingTemplate/ReportingHeader/ReportingHeaderList';
import ReportingHeaderModify from './ReportingTemplate/ReportingHeader/ReportingHeaderModify';
import IdaqExportList from './IdaqExport/IdaqExportList';
import IdaqExportModify from './IdaqExport/IdaqExportModify';

const Home = props => {
  return (
    <div className='inner-section-root'>
      <TabBar
        items={[
          { to: '/export/data-export', label: 'Data Export', onlyActiveOnIndex: true },
          // { to: '/export/logs', label: 'Logs' },
          // { to: '/export/parameter-template', label: 'Export Parameter Template' },
          { to: `/export/report`, label: 'Report Template' },
          { to: `/export/export`, label: 'Report Download' },
          { to: '/export/raw-data-export', label: 'Raw Data Export', onlyActiveOnIndex: true },
          { to: '/export/idaq-export', label: 'Idaq Export', onlyActiveOnIndex: true },
        ]}
      />
      <div className='inner-section-content'>
        {props.children}
      </div>
    </div>
  );
};

export const DataDeliveryRoutes = () => (
  <Route component={Home}>
    <IndexRedirect to='data-export' />
    <Route path='data-export' component={DataExportList}>
      <Route path='add' component={DataExportAdd} />
      <Route path=':id' component={DataExportEdit} />
      <Route path=':id/run' component={DataExportRun} />
    </Route>

    <Route path='report' component={ReportingTemplateIndex}>
      <IndexRedirect to='template' />
      <Route path='template' component={ReportingTemplateList} >
        <Route path=':id' component={ReportingTemplateModify} />
      </Route>
      <Route path='header' component={ReportingHeaderList} >
        <Route path=':id' component={ReportingHeaderModify} />
      </Route>
    </Route>


    <Route path='export' component={ReportGenerate} />

    <Route path='raw-data-export' component={RawDataExportList}>
      <Route path=':id/audit' component={RawDataExportAudit} />
      <Route path=':id' component={RawDataExportModify} />
    </Route>

    <Route path="idaq-export" component={IdaqExportList}>
      <Route path=':id' component={IdaqExportModify} />
      {/* <Route path=':id/audit' component={IdaqExportList} /> */}
    </Route>

    <Route path='logs' component={DataDeliveryLogs} />
    <Route path='parameter-template' component={DataDeliveryParameterTemplate} />
  </Route>
)


// WEBPACK FOOTER //
// ./src/components/DataDelivery/routes.js